import { ReactNode } from 'react';
import { Amount } from '@mews-commander/types';
import { FlexSpaceBetweenAlignCenter, SpacingSmallAll, WithBreakpointRange, isMobile } from '@mews-commander/ui';
import { Title, Stack, withBreakpointRange } from '@optimus-web/core';
import AccountBalance from './AccountBalance';
import NewAccountBalance from './NewAccountBalance';

interface Props extends WithBreakpointRange {
    amount?: Amount;
    buttons: React.ReactNode[];
    title?: ReactNode;
}

const BillListHeader = ({ title, buttons, breakpointRange, amount }: Props) => {
    const titleEl = title && <Title level={2}>{title}</Title>;

    return isMobile(breakpointRange) ? (
        <SpacingSmallAll>
            {titleEl}
            <AccountBalance amount={amount} inline />
            <Stack itemAlignment="center" alignment="end" spacing="100">
                {buttons}
            </Stack>
        </SpacingSmallAll>
    ) : (
        <FlexSpaceBetweenAlignCenter>
            <Stack spacing="200">
                {titleEl}
                <Stack itemAlignment="center" alignment="end" spacing="100">
                    {buttons}
                </Stack>
            </Stack>
            <NewAccountBalance amount={amount} />
        </FlexSpaceBetweenAlignCenter>
    );
};

export default withBreakpointRange(BillListHeader);
